import { makeAutoObservable } from 'mobx'

class Stats {
  columns = [
    {id: 1, title: 'Назв-е товара', initialWidth: '30rem'},
    {id: 2, title: 'Артикул', initialWidth: '14rem'},
    {id: 3, title: 'Кол-во', initialWidth: '14rem'},
    {id: 4, title: 'Логотип', initialWidth: '16rem'},
    {id: 5, title: 'М-д печати', initialWidth: '16rem'},
    {id: 7, title: 'Кол-во цветов', initialWidth: '6.7rem', stampStageOnly: true},
    {id: 8, title: 'Менеджер', initialWidth: '14rem'},
    {id: 9, title: '№ зак.', initialWidth: '19rem'},
    {id: 10, title: 'Заказчик', initialWidth: '20.8rem'},
    {id: 11, title: 'Дата заказа', initialWidth: '13rem'},
    {id: 12, title: 'Дата готов.', initialWidth: '13rem'},
  ]
  initialGridTemplate = [30, 14, 14, 16, 16, 6.7, 14, 19, 20.8, 13, 13]


  constructor() {
    makeAutoObservable(this)
  }

  updateGridTemplate(value){
    if(value) {
      this.initialGridTemplate = value
    }
  }
  calculateInitialWidth(containerWidth) {
    const totalWidth = this.initialGridTemplate.reduce((acc, colWidth) => {
      acc += (colWidth * 10)
      return acc
    }, 0)
    const widthDiff = (containerWidth - totalWidth) / 10
    if(widthDiff > 0) {
      const columnsCount = this.columns.length
      const diffPart = Math.max(widthDiff / columnsCount)
      const updatedGridTemplate = this.initialGridTemplate.map((colWidth) => (colWidth += diffPart))
      this.updateGridTemplate(updatedGridTemplate)
    }
  }
}

const statsStore = new Stats()

export default statsStore
